module.exports = __webpack_public_path__ + "static/media/houqinbaozhangliucheng.c503bba6.png";